module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1073.107d48a4.png";